import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";

export const PublicRoute = ({ children }) => {
	const { isAuth, loading } = useContext(AuthContext);
	const location = useLocation();

	if (loading) {
		return <BackdropLoading />;
	}

	if (isAuth) {
		return <Navigate to="/" state={{ from: location }} replace />;
	}

	return children;
};

export const PrivateRoute = ({ children }) => {
	const { isAuth, loading } = useContext(AuthContext);
	const location = useLocation();

	if (loading) {
		return <BackdropLoading />;
	}

	if (!isAuth) {
		return <Navigate to="/login" state={{ from: location }} replace />;
	}

	return children;
};
